import { makeAutoObservable } from 'mobx'

export class CheckStore<Value = string> {
  private _selection = new Set<Value>()
  private _value = new Set<Value>()
  private _search = ''

  constructor() {
    makeAutoObservable(this)
  }

  get selection(): Set<Value> {
    return this._selection
  }

  get value(): Set<Value> {
    return this._value
  }

  get search(): string {
    return this._search
  }

  set search(value: string) {
    this._search = value
  }

  toggle(value: Value) {
    if (this._selection.has(value)) this._selection.delete(value)
    else this._selection.add(value)
  }

  selected(value: Value): boolean {
    return this._selection.has(value)
  }

  clear() {
    this._selection.clear()
  }

  reset() {
    this.clear()
    this.apply()
  }

  apply() {
    this._value = new Set(this._selection)
  }

  unapply() {
    this._selection = new Set(this._value)
  }
}
